<template>
  <LoadingSpinner :visible="isLoading" />
  <template  v-if="currentComponent ">
      <HomeTopBar v-if="currentComponent.name !== 'Login' &&  currentComponent.name !== 'Signup' && currentComponent.name !== 'CompanySignup' && currentComponent.name !== 'ResetPassword' && currentComponent.name !== 'NotFound' && currentComponent.name !== 'confirmEmail'" @goto-home-click="home"
      @get-started-click="getStarted"
      @login-click="login" />
  <div :class="{ 'container mx-auto': currentComponent.name !== 'Login' && currentComponent.name !== 'GetStarted' && currentComponent.name !== 'Signup' && currentComponent.name !== 'CompanySignup' && currentComponent.name !== 'ResetPassword'  && currentComponent.name !== 'PrivacyPolicy' && currentComponent.name !== 'TermsOfService' && currentComponent.name !== 'NotFound' && currentComponent.name !== 'confirmEmail'}" >
  <component :is="currentComponent" />
</div>
<HomeFooter class="mt-5" v-if="currentComponent.name !== 'Login' &&  currentComponent.name !== 'Signup' && currentComponent.name !== 'CompanySignup' && currentComponent.name !== 'ResetPassword' && currentComponent.name !== 'GetStarted' && currentComponent.name !== 'NotFound' && currentComponent.name !== 'confirmEmail'" />
</template>


  <App
    v-else
  />
</template>

<script>
import App from './App.vue'
import Login from './pages/Login'
import JobList from './pages/JobList.vue'
import Signup from './pages/Signup.vue'
import Home from './pages/Home.vue'
import JobDetail from './pages/JobDetail.vue'
import GetStarted from './pages/GetStarted.vue'
import CompanySignup from './pages/CompanySignup.vue'
import { mapState } from 'vuex'
import ResetPassword from './pages/ResetPassword.vue'
import MailConfirmation from './pages/MailConfirmation.vue'
import NotFound from './pages/NotFound.vue'
import PaymentSuccess from './pages/PaymentSuccess.vue'
import PaymentFailed from './pages/PaymentFailed.vue'
import Unauthorized from './pages/Unauthorized.vue'
import Faq from './pages/Faq.vue'
import About from './pages/About.vue'
import ContactUs from './pages/ContactUs.vue'
import HowItWorks from './pages/HowItWorks.vue'
import HomeRecruiters from './pages/HomeRecruiters.vue'
import HomeCompany from './pages/HomeCompany.vue'
import HomeCandidates from './pages/HomeCandidates.vue'
import linkedinCallbackVue from './pages/linkedin-callback.vue'
import LoadingSpinner from './components/LoadingSpinner.vue'
import PrivacyPolicy from './pages/PrivacyPolicy.vue'
import TermsOfService from './pages/TermsOfService.vue'
import HomeTopBar from './pages/HomeTopbar.vue'
import HomeFooter from './pages/HomeFooter.vue'
import { loadingEventBus } from './router'

export default {
  data() {
    return {
      theme: 'blue',
      layoutMode: 'light',
      topbarTheme: 'blue',
      menuTheme: 'light',
      isLoading: false,
    }
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
    }),
    currentComponent() {
      const routeName = this.$route.name

      // Define the component mapping
      const componentsMap = {
        login: Login,
        home: Home,
        signUp: Signup,
        companySignup: CompanySignup,
        jobs: JobList,
        resetPassword: ResetPassword,
        confirmEmail: MailConfirmation,
        paymentSuccess: PaymentSuccess,
        paymentFailed: PaymentFailed,
        getStarted: GetStarted,
        notFound: NotFound,
        unauthorized: Unauthorized,
        faq: Faq,
        about: About,
        contactUs: ContactUs,
        howItWorks: HowItWorks,
        'home-recruiters': HomeRecruiters,
        'home-companies': HomeCompany,
        'home-candidates': HomeCandidates,
        linkedinCallback: linkedinCallbackVue,
        privacyPolicy: PrivacyPolicy,
        termsOfService: TermsOfService,
      }

      if (routeName === 'jobDetail' && !this.account.loggeduser) {
        return JobDetail
      }

      // Return the matching component or null if none is found
      return (
        componentsMap[routeName] ||
        (this.$route.name === 'notFound' ? NotFound : null)
      )
    },
  },
  methods: {
    onLayoutChange(layout) {
      this.layoutMode = layout
      this.$appState.layoutMode = layout
      this.menuTheme = layout

      const logo = document.getElementById('logo')
      logo.src = 'assets/layout/images/logo-light.png'

      if (layout === 'dark') {
        this.topbarTheme = 'dark'
      } else {
        this.topbarTheme = 'blue'
      }
    },
    onTopbarThemeChange(theme) {
      this.topbarTheme = theme.name

      const themeName = theme.name
      const logo = document.getElementById('logo')

      if (['white', 'yellow', 'amber', 'orange', 'lime'].includes(themeName)) {
        logo.src = 'assets/layout/images/logo-dark.png'
      } else {
        logo.src = 'assets/layout/images/logo-light.png'
      }
    },
    onMenuTheme(menuTheme) {
      this.menuTheme = menuTheme.name
    },
  },
  mounted() {
    // Listen for loading events
    loadingEventBus.on('loading', (isLoading) => {
      this.isLoading = isLoading
    })
  },
  beforeUnmount() {
    // Clean up event listeners
    loadingEventBus.off('loading')
  },
  components: {
    App,
    LoadingSpinner,
    HomeTopBar,
    HomeFooter,
  },
}
</script>
